<template>
    <Teleport to="body">
        <Transition name="student-mobile-nav-fade">
            <div
                v-if="showMenuMobile"
                class="student-mobile-nav__backdrop"
                @click="fecharMenuHeader"
            />
        </Transition>

        <Transition name="student-mobile-nav-drawer">
            <aside
                v-if="showMenuMobile"
                id="student-portal-mobile-menu"
                ref="panelRef"
                class="student-mobile-nav__panel"
                :class="{ 'student-mobile-nav__panel--dark': dark }"
                role="dialog"
                aria-modal="true"
                :aria-label="$t('student.mobileMenu.portalMenu')"
                tabindex="-1"
            >
                    <header class="student-mobile-nav__header">
                        <span class="student-mobile-nav__title">{{ $t('student.mobileMenu.menu') }}</span>
                        <button
                            type="button"
                            class="student-mobile-nav__close"
                            :aria-label="$t('student.mobileMenu.closeMenu')"
                            @click="fecharMenuHeader"
                        >
                            <v-icon size="22">mdi-close</v-icon>
                        </button>
                    </header>

                    <router-link
                        class="student-mobile-nav__profile"
                        to="/aluno/perfil"
                        @click="fecharMenuHeader"
                    >
                        <div class="student-mobile-nav__avatar" aria-hidden="true">
                            {{ userInitials }}
                        </div>
                        <div class="student-mobile-nav__profile-text">
                            <span class="student-mobile-nav__profile-name">{{
                                fullName || $t('student.mobileMenu.account')
                            }}</span>
                            <span class="student-mobile-nav__profile-hint"
                                >{{ $t('student.mobileMenu.profileAndData') }}</span
                            >
                        </div>
                        <v-icon size="20" class="student-mobile-nav__chevron"
                            >mdi-chevron-right</v-icon
                        >
                    </router-link>

                    <nav
                        class="student-mobile-nav__nav"
                        :aria-label="$t('student.header.mainNav')"
                    >
                        <ul class="student-mobile-nav__list">
                            <li
                                v-for="item in navItems"
                                :key="item.to + item.label"
                            >
                                <router-link
                                    :to="item.to"
                                    custom
                                    v-slot="{
                                        href,
                                        navigate,
                                        isActive,
                                        isExactActive,
                                    }"
                                >
                                    <a
                                        :href="href"
                                        class="student-mobile-nav__link"
                                        :class="{
                                            'student-mobile-nav__link--active':
                                                item.exact
                                                    ? isExactActive
                                                    : isActive,
                                        }"
                                        @click="
                                            (e) => {
                                                navigate(e);
                                                fecharMenuHeader();
                                            }
                                        "
                                    >
                                        <v-icon
                                            class="student-mobile-nav__link-icon"
                                            size="22"
                                            >{{ item.icon }}</v-icon
                                        >
                                        <span>{{ item.label }}</span>
                                    </a>
                                </router-link>
                            </li>
                        </ul>
                    </nav>

                    <div class="student-mobile-nav__actions">
                        <button
                            type="button"
                            class="student-mobile-nav__action-btn"
                            @click="changeViewMode"
                        >
                            <v-icon size="22">{{
                                dark ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent'
                            }}</v-icon>
                            <span>{{ dark ? $t('student.mobileMenu.lightMode') : $t('student.mobileMenu.darkMode') }}</span>
                        </button>

                        <button
                            type="button"
                            class="student-mobile-nav__action-btn student-mobile-nav__action-btn--danger"
                            @click="onLogout"
                        >
                            <v-icon size="22">mdi-logout</v-icon>
                            <span>{{ $t('student.header.logout') }}</span>
                        </button>
                    </div>

                    <footer class="student-mobile-nav__footer">
                        <p class="student-mobile-nav__version">
                            {{ $t('common.version') }}: {{ versionLabel }}
                        </p>
                    </footer>
            </aside>
        </Transition>
    </Teleport>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { canAccessTeamMonitoring } from '@/utils/corporate/users';
import { loadAppVersion } from '@/utils/appVersion';

export default {
    name: 'MobileMenu',
    props: {
        showMenuMobile: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            versionPortalWeeduc: '',
        };
    },
    created() {
        loadAppVersion().then((data) => {
            this.versionPortalWeeduc = data.student || '';
        });
    },
    computed: {
        ...mapState(['dark', 'user']),
        ...mapState('portal', ['dataWebsitePortal2']),
        canAccessMonitoring() {
            return canAccessTeamMonitoring(this.user);
        },
        fullName() {
            return this.user?.name || '';
        },
        userInitials() {
            const n = this.fullName.trim();
            if (!n) return '?';
            const parts = n.split(/\s+/).filter(Boolean);
            if (parts.length >= 2) {
                return (
                    parts[0][0] + parts[parts.length - 1][0]
                ).toUpperCase();
            }
            return n.slice(0, 2).toUpperCase();
        },
        versionLabel() {
            return this.versionPortalWeeduc || '—';
        },
        isCourseRoute() {
            return this.$route.path.startsWith('/aluno/curso/');
        },
        coursePlayerPath() {
            const slug = this.$route.params.slug;
            return slug ? `/aluno/curso/${slug}` : '/aluno/dashboard';
        },
        navItems() {
            void this.$i18n.locale;
            const items = [
                {
                    to: '/aluno',
                    label: this.$t('student.header.home'),
                    icon: 'mdi-home-outline',
                    exact: true,
                },
            ];

            if (this.isCourseRoute) {
                items.push({
                    to: this.coursePlayerPath,
                    label: this.$t('student.header.course'),
                    icon: 'mdi-play-circle-outline',
                    exact: false,
                });
            }

            const w = this.dataWebsitePortal2;
            if (w?.showInquiry == 1) {
                items.push({
                    to: '/aluno/duvidas',
                    label: this.$t('student.header.myDoubts'),
                    icon: 'mdi-help-circle-outline',
                    exact: false,
                });
            }
            if (w?.showForum == 1) {
                items.push({
                    to: '/aluno/forum',
                    label: this.$t('student.header.forums'),
                    icon: 'mdi-forum-outline',
                    exact: false,
                });
            }
            if (w?.showCertificate == 1) {
                items.push({
                    to: '/aluno/certificados',
                    label: this.$t('student.header.certificates'),
                    icon: 'mdi-certificate-outline',
                    exact: false,
                });
            }
            if (this.canAccessMonitoring) {
                items.push({
                    to: '/aluno/acompanhamento',
                    label: this.$t('student.header.monitoring'),
                    icon: 'mdi-account-eye-outline',
                    exact: false,
                });
            }
            if (w?.showNotification != 0) {
                items.push({
                    to: '/aluno/notificacoes',
                    label: this.$t('student.mobileMenu.notices'),
                    icon: 'mdi-bell-outline',
                    exact: false,
                });
            }

            return items;
        },
    },
    watch: {
        showMenuMobile(open) {
            if (open) {
                this.$nextTick(() => {
                    this.$refs.panelRef?.focus?.();
                });
            }
        },
    },
    methods: {
        ...mapActions(['toggleDarkMode']),
        fecharMenuHeader() {
            this.$emit('fechar-menu-header');
        },
        changeViewMode() {
            this.toggleDarkMode({ dark: !this.dark, manual: true });
        },
        onLogout() {
            this.fecharMenuHeader();
            this.$emit('logout');
        },
    },
};
</script>

<style scoped>
.student-mobile-nav__backdrop {
    position: fixed;
    inset: 0;
    z-index: 2099;
    background: rgba(15, 23, 42, 0.45);
    backdrop-filter: blur(2px);
}

.student-mobile-nav__panel {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 2100;
    display: flex;
    flex-direction: column;
    width: min(90vw, 360px);
    max-width: 100%;
    height: 100%;
    height: 100dvh;
    padding: 0;
    margin: 0;
    background: #FFFFFF;
    color: #1F2937;
    box-shadow: -4px 0 24px rgba(15, 23, 42, 0.1);
    border-radius: 12px 0 0 12px;
    overflow: hidden;
}

.student-mobile-nav__panel--dark {
    background: #141318;
    color: #f1f5f9;
    box-shadow: -8px 0 32px rgba(0, 0, 0, 0.45);
}

.student-mobile-nav__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px 12px;
    border-bottom: 1px solid #E4E7EC;
}

.student-mobile-nav__panel--dark .student-mobile-nav__header {
    border-bottom-color: rgba(255, 255, 255, 0.08);
}

.student-mobile-nav__title {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #64748b;
}

.student-mobile-nav__panel--dark .student-mobile-nav__title {
    color: #94a3b8;
}

.student-mobile-nav__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    border-radius: 10px;
    background: rgba(15, 23, 42, 0.06);
    color: inherit;
    cursor: pointer;
    transition: background 0.2s;
}

.student-mobile-nav__panel--dark .student-mobile-nav__close {
    background: rgba(255, 255, 255, 0.08);
}

.student-mobile-nav__close:hover {
    background: rgba(25, 199, 208, 0.2);
}

.student-mobile-nav__profile {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    text-decoration: none;
    color: inherit;
    border-bottom: 1px solid rgba(15, 23, 42, 0.08);
    transition: background 0.2s;
}

.student-mobile-nav__panel--dark .student-mobile-nav__profile {
    border-bottom-color: rgba(255, 255, 255, 0.08);
}

.student-mobile-nav__profile:active {
    background: rgba(25, 199, 208, 0.08);
}

.student-mobile-nav__avatar {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 14px;
    background: linear-gradient(145deg, #19c7d0, #0d9488);
    color: #fff;
    font-weight: 700;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.student-mobile-nav__profile-text {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.student-mobile-nav__profile-name {
    font-weight: 600;
    font-size: 15px;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.student-mobile-nav__profile-hint {
    font-size: 13px;
    color: #64748b;
}

.student-mobile-nav__panel--dark .student-mobile-nav__profile-hint {
    color: #94a3b8;
}

.student-mobile-nav__chevron {
    flex-shrink: 0;
    opacity: 0.45;
}

.student-mobile-nav__nav {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 8px 10px 12px;
}

.student-mobile-nav__list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.student-mobile-nav__link {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 12px;
    margin-bottom: 4px;
    border-radius: 12px;
    text-decoration: none;
    color: #0f172a;
    font-size: 15px;
    font-weight: 500;
    transition:
        background 0.15s,
        color 0.15s;
}

.student-mobile-nav__panel--dark .student-mobile-nav__link {
    color: #e2e8f0;
}

.student-mobile-nav__link:hover {
    background: rgba(25, 199, 208, 0.1);
}

.student-mobile-nav__link--active {
    background: rgba(25, 199, 208, 0.18);
    color: #0f766e;
    font-weight: 600;
}

.student-mobile-nav__panel--dark .student-mobile-nav__link--active {
    color: #5eead4;
    background: rgba(45, 212, 191, 0.12);
}

.student-mobile-nav__link-icon {
    flex-shrink: 0;
    opacity: 0.9;
    color: #19c7d0 !important;
}

.student-mobile-nav__mode {
    margin: 8px 12px 0;
    padding: 12px;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.student-mobile-nav__panel--dark .student-mobile-nav__mode {
    border-color: rgba(255, 255, 255, 0.08);
}

.student-mobile-nav__mode legend {
    padding: 0 4px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #94a3b8;
}

.student-mobile-nav__mode-option {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    padding: 10px 12px;
    border-radius: 10px;
    background: rgba(15, 23, 42, 0.04);
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
}

.student-mobile-nav__panel--dark .student-mobile-nav__mode-option {
    background: rgba(255, 255, 255, 0.06);
}

.student-mobile-nav__mode-option:has(input:checked) {
    background: rgba(37, 8, 145, 0.1);
    color: #250891;
    font-weight: 600;
}

.student-mobile-nav__panel--dark .student-mobile-nav__mode-option:has(input:checked) {
    background: rgba(124, 58, 237, 0.18);
    color: #c4b5fd;
}

.student-mobile-nav__mode-option input {
    accent-color: #250891;
    width: 16px;
    height: 16px;
}

.student-mobile-nav__actions {
    padding: 8px 12px 0;
    border-top: 1px solid rgba(15, 23, 42, 0.08);
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.student-mobile-nav__panel--dark .student-mobile-nav__actions {
    border-top-color: rgba(255, 255, 255, 0.08);
}

.student-mobile-nav__action-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 12px 12px;
    border: none;
    border-radius: 12px;
    background: rgba(15, 23, 42, 0.04);
    color: inherit;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    text-align: left;
    transition: background 0.15s;
}

.student-mobile-nav__panel--dark .student-mobile-nav__action-btn {
    background: rgba(255, 255, 255, 0.06);
}

.student-mobile-nav__action-btn:hover {
    background: rgba(25, 199, 208, 0.12);
}

.student-mobile-nav__action-btn--danger {
    color: #b91c1c;
}

.student-mobile-nav__panel--dark .student-mobile-nav__action-btn--danger {
    color: #f87171;
}

.student-mobile-nav__footer {
    padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0));
    margin-top: auto;
}

.student-mobile-nav__version {
    margin: 0;
    font-size: 11px;
    color: #94a3b8;
    text-align: center;
}

.student-mobile-nav__panel--dark .student-mobile-nav__version {
    color: #64748b;
}

/* Transitions */
.student-mobile-nav-fade-enter-active,
.student-mobile-nav-fade-leave-active {
    transition: opacity 0.25s ease;
}

.student-mobile-nav-fade-enter-from,
.student-mobile-nav-fade-leave-to {
    opacity: 0;
}

.student-mobile-nav-drawer-enter-active,
.student-mobile-nav-drawer-leave-active {
    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.student-mobile-nav-drawer-enter-from,
.student-mobile-nav-drawer-leave-to {
    transform: translateX(100%);
}
</style>
